"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var public_toolbar_html_1 = __importDefault(require("./public-toolbar.html"));
require("./public-toolbar.less");
(function (module) {
    module.component('prPublicToolbar', {
        templateUrl: public_toolbar_html_1.default,
        require: {
            '$bdyCtrl': '^^prBody'
        }
    });
})(angular.module('qualtrics.pr'));
